export enum  AiAnalysisType
 {
    LegalAnalysisNotes = 0,
    LegalAnalysisReport = 1,
    GenerateFullReport = 2,
    GenerateSynopsis = 3,
    CaseLawSummaryDFIR = 4,
    CaseLawSummaryCriminalPolice = 5,
    CaseLawSummaryCivil = 6,
    LegalQandA = 7,
    LegalAnalysisReportProsecutor = 8,
    LegalAnalysisReportDefense = 9,
    TranslateToEnglish = 10,
    ExecutiveSummary = 11,
    ExecutiveSummaryOfCrimeReport = 12,
    AudioTranscriptionToEnglish = 13,
    AudioTranscriptionToAudioLanguage = 14,
    FormatTranscribedText = 15,
    Sentiment = 16,
    AudioTranscriptionRewriteAsNoteTextForPolice = 17,
    AudioTranscriptionRewriteAsNoteTextForDFIR = 18,
    AudioTranscriptionRewriteAsNoteTextForPrivateInvestigators = 19,
    AudioTranscriptionSimpleRewrite = 20,
    InvestNextSteps = 21,
    InvestCritiquePastSteps = 22,
    ExpertDFIR = 23,
    ExpertOSINT = 24,
    ExpertLawEnforcement = 25,
    ExpertLegalAustralia = 26,
    ExpertLegalCanada = 27,
    ExpertLegalUSA = 28,
    ExpertLegalUK = 29,
    ExpertLegalPhillipines = 30,
    ExpertLegalThailand = 31,
    ExtractPersonDetailsFromOcrText = 32,
    NotesQandA = 33,


}